import { User } from '../../user/shared/user.model';
import { IAccount } from './account.service';
import { Category } from '../../category/shared/category.model';

export class Account implements IAccount {
  id?: string;
  amount?: number;
  supplierName?: string;
  supplierPhone?: string;
  paidBy?: User;
  paidOn?: Date;
  processedOn?: Date;
  createdOn?: Date;
  createdBy?: User;
  modifiedOn?: Date;
  modifiedBy?: User;
  notes?: string;
  category?: Category;
  archivedOn?: Date;
  images?: string[];

  get paidById() {return this.paidBy ? this.paidBy.id : undefined; }
  get categoryId() {return this.category ? this.category.id : undefined; }
  get categoryName() {return this.category ? this.category.name : undefined; }

  constructor(account?: IAccount) {
    if (account) {
      this.id = account.id;
      this.amount = account.amount;
      this.supplierName = account.supplierName;
      this.supplierPhone = account.supplierPhone;
      this.paidBy = account.paidBy;
      this.paidOn = account.paidOn;
      this.processedOn = account.processedOn;
      this.createdOn = account.createdOn;
      this.createdBy = account.createdBy;
      this.modifiedOn = account.modifiedOn;
      this.modifiedBy = account.modifiedBy;
      this.notes = account.notes;
      this.category = account.category;
      this.archivedOn = account.archivedOn;
      this.images = account.images;
    }
  }
}
